import React from "react";
import { FiLoader, FiAlertTriangle } from "react-icons/fi";

export default function Status({ state = "loading", title, note, action }) {
  const isLoading = state === "loading";
  return (
    <div className="status">
      <div className={`status-card ${isLoading ? "is-loading" : "is-error"}`} role="status" aria-live="polite">
        <div className="status-icon">
          {isLoading ? <FiLoader className="spin" /> : <FiAlertTriangle />}
        </div>
        <h3 className="status-title">{title}</h3>
        {note && <p className="status-note">{note}</p>}
        {action && <div className="status-actions">{action}</div>}
      </div>
    </div>
  );
}
